import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  const handleCheckoutClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart');
    }
  };
  return <section id="comprar" className="py-20 md:py-32 px-5 md:px-8 relative overflow-hidden" data-id="element-75">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4a853] rounded-full blur-[150px] opacity-10 -z-10 pointer-events-none" data-id="element-76"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-b from-[#1a1f3a] to-[#0a0e1a] p-8 md:p-12 rounded-3xl border border-[#d4a853]/40 shadow-[0_0_50px_rgba(212,168,83,0.15)]" data-id="element-78">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-79">
            Recupera el control de tus noches hoy mismo
          </h2>

          <p className="text-gray-300 text-lg mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-80">
            El acceso completo al{' '}
            <strong className="text-white" data-id="element-81">Protocolo Silencio 11PM</strong>{' '}
            (Ebook + Guías + Checklists) está disponible por una fracción de lo
            que cuesta una sola consulta con un especialista o una máquina de
            sonido profesional.
          </p>

          <div className="my-10 space-y-4" data-id="element-82">
            <p className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-83">
              PAGO ÚNICO • ACCESO INMEDIATO
            </p>
            <div className="flex justify-center items-center gap-3" data-id="element-84">
              <span className="text-gray-500 line-through text-2xl md:text-3xl font-semibold" data-id="element-85">
                $41.99 USD
              </span>
            </div>
            <div className="flex justify-center" data-id="element-86">
              <span className="bg-green-500/20 text-green-400 border border-green-500/30 font-bold text-sm md:text-base px-4 py-1.5 rounded-full" data-id="element-87">
                🔥 Ahorras $30.00 USD
              </span>
            </div>
            <div className="flex justify-center items-start gap-2 pt-2" data-id="element-88">
              <span className="text-3xl font-bold text-[#d4a853] mt-2" data-id="element-89">$</span>
              <span className="text-7xl font-bold text-[#d4a853] tracking-tighter" data-id="element-90">
                11.99
              </span>
              <span className="text-xl font-bold text-[#d4a853] mt-8" data-id="element-91">USD</span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-92">
            <a href="https://pay.hotmart.com/M105215372D?checkoutMode=10" onClick={handleCheckoutClick} className="bg-[#d4a853] hover:bg-[#e5b964] text-[#0a0e1a] font-bold text-xl md:text-2xl px-8 py-5 rounded-xl transition-all duration-300 shadow-[0_0_30px_rgba(212,168,83,0.5)] transform hover:scale-105 active:scale-95 w-full max-w-md flex flex-col items-center justify-center gap-1" data-id="element-93">
              <span data-id="element-94">¡SÍ, QUIERO DORMIR EN PAZ AHORA!</span>
            </a>
            <p className="text-gray-400 text-sm mt-2" data-id="element-95">
              🔒 Pago 100% seguro procesado por Hotmart. Acceso inmediato tras
              el pago.
            </p>
            <p className="text-white font-medium mt-4" data-id="element-96">
              Tu descanso no puede esperar otra noche más.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}